// extracted by mini-css-extract-plugin
module.exports = {"loginTeams":"TeamsLogin_loginTeams__ZW-XZ","error":"TeamsLogin_error__ITwbH"};